import { z } from 'zod';

/** メンバー種別（タブ / アップロード対象） */
const importTypeSearch = z.enum(['EMPLOYEE', 'CONTRACTOR', 'BOARD_MEMBER', 'COLLABORATOR']).catch('EMPLOYEE').default('EMPLOYEE');

/** CSV 読み込みリストの検索パラメータ（タブ状態 + ページネーション） */
export const CsvImportListSearchSchema = z.object({
  type: importTypeSearch,
  page: z.number().int().min(1).catch(1).default(1),
  pageSize: z.number().int().min(1).max(2000).catch(100).default(100)
});
/** アップロード画面の検索パラメータ（対象メンバー種別） */
export const CsvImportUploadSearchSchema = z.object({
  type: importTypeSearch
});